module.exports = __webpack_public_path__ + "img/ticketlog.5a08cdc7.png";